// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_label_Sa5zHkSeeUJEfyPOGbkw {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.style-module_value_DBJP9rm5QZ5f_DFlIxS7 {
  display: block;
  margin-bottom: 0.95rem;
}`, "",{"version":3,"sources":["webpack://./src/containers/MarketOfferView/components/Details/style.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,sBAAA;AACF","sourcesContent":[".label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n}\n\n.value {\n  display: block;\n  margin-bottom: 0.95rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `style-module_label_Sa5zHkSeeUJEfyPOGbkw`,
	"value": `style-module_value_DBJP9rm5QZ5f_DFlIxS7`
};
export default ___CSS_LOADER_EXPORT___;
